"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gets next Sunday of current week
 * @param d Date
 */
exports.getEndOfWeek = (d) => {
    d = new Date(d);
    const day = d.getDay();
    const diff = d.getDate() + 7 - (day == 0 ? 7 : day); // adjust when day is sunday
    return new Date(d.setDate(diff));
};
/**
 * Gets previous Monday of current week
 * @param d Date
 */
exports.getStartOfWeek = (d) => {
    d = new Date(d);
    const day = d.getDay();
    const diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
};
/**
 * Returns a new Date that is x number of days in the past
 * @param days Days in past
 */
exports.daysAgo = (days) => {
    const midnightToday = (new Date()).setHours(0, 0, 0, 0);
    return new Date(midnightToday - (days * 24 * 60 * 60 * 1000));
};
/**
 * Returns ISO 8601 formatted date string.
 * Note: does not contain time or timezone.
 * @param d Date
 */
exports.iso8601Date = (d) => {
    if (!(d instanceof Date)) {
        d = new Date(d);
    }
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};
